import React from 'react'
import { Card } from 'react-bootstrap'

const About: React.FC = () => {
  return (
    <>
      <Card.Title as="h2">About</Card.Title>
      <Card.Text>
        The goal of this website is to provide an easy to access list of recipes without any of the
        pains of today's websites. Other sites are plagued with slow loading times and pop-up ads
        that make the experience unpleasant for users who want to quickly review their favorite
        recipes. Our homepage simply contains the list of the hosted recipes along with a search bar
        for quick lookups. Each recipe themselves have a consice description of the required
        ingredients and the directions to follow. The underlying techonology is designed to minimize
        loading times and maximize responsiveness so that it works great even on your phone. There
        are no ads or pop-ups to distract you from the main content.
      </Card.Text>
      <Card.Text>
        All of the source code is freely available on GitHub at{' '}
        <Card.Link href="https://github.com/ellishg/laughing-potato">
          https://github.com/ellishg/laughing-potato
        </Card.Link>{' '}
        for anyone to contribute to. If you would like to add your own recipe, please make a pull
        request at{' '}
        <Card.Link href="https://github.com/ellishg/urban-bassoon">
          https://github.com/ellishg/urban-bassoon
        </Card.Link>
        .
      </Card.Text>
      <Card.Subtitle as="h3">Why laughing-potato?</Card.Subtitle>
      <Card.Text>
        The name laughing-potato was randomly generated by GitHub when I created the repo. If you
        have a better name idea, feel free to buy me the domain and I can change it{' '}
        <span role="img" aria-label="sheep">
          😄
        </span>
        .
      </Card.Text>
    </>
  )
}

export default About
